import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/GenerateAgencyLogoSignedUrl.graphql';
import { Query, QuerygenerateAgencyLogoSignedUrlArgs } from '../../__generated__/globalTypes';

export const useGenerateAgencyLogoSignedUrlQuery = (
  options?: QueryHookOptions<Query, QuerygenerateAgencyLogoSignedUrlArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerygenerateAgencyLogoSignedUrlArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useGenerateAgencyLogoSignedUrlLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerygenerateAgencyLogoSignedUrlArgs>
): QueryResult<Query, QuerygenerateAgencyLogoSignedUrlArgs> & {
  getGenerateAgencyLogoSignedUrl: LazyQueryExecFunction<Query, QuerygenerateAgencyLogoSignedUrlArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getGenerateAgencyLogoSignedUrl, result] = useLazyQuery<Query, QuerygenerateAgencyLogoSignedUrlArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getGenerateAgencyLogoSignedUrl, ...result };
};

export const useGenerateAgencyLogoSignedUrlPromiseQuery = () => {
  const client = useApolloClient();

  const getGenerateAgencyLogoSignedUrl = useCallback(
    (options?: Omit<QueryOptions<QuerygenerateAgencyLogoSignedUrlArgs, Query>, 'query'>) =>
      client.query<Query, QuerygenerateAgencyLogoSignedUrlArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getGenerateAgencyLogoSignedUrl };
};
// Suspense Query Hooks
export const useGenerateAgencyLogoSignedUrlSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerygenerateAgencyLogoSignedUrlArgs>
) => {
  const result = useSuspenseQuery<Query, QuerygenerateAgencyLogoSignedUrlArgs>(QUERY, {
    ...options
  });

  return result;
};
